module.exports = __webpack_public_path__ + "img/step5.6d84dc41.png";